//* 组件库
import type { UiTableOption2 } from "various-ui";
//* 组件属性
import type { ModuleProps } from "../index";
export const useOptions = (define: ModuleProps) => {
    //* 插件
    const i18n = useI18n();
    if (define.origin.species == 9606) {
        return {
            info: <UiTableOption2[]>[
                { key: "ncbi", name: "NCBI", align: "center" },
                { key: "transcripts", name: i18n.t("Transcript", 2), align: "center" },
                { key: "exon", name: i18n.t("Exon", 2), align: "center" },
                { key: "size", name: i18n.t("Layout.TypeLength", { type: "Gene" }, 2), align: "center" },
                { key: "molecular_weight", name: i18n.t("MolecularWeight"), align: "center" },
                { key: "mutations", name: i18n.t("Layout.TypeMutations", { type: "Gene" }, 2), align: "center" },
                { key: "related_diseases", name: i18n.t("RelatedDiseases"), align: "center" },
                { key: "related_models", name: i18n.t("RelatedModels"), align: "center" },
                { key: "references", name: i18n.t("Reference"), align: "center" },
            ],
        };
    } else {
        return {
            info: <UiTableOption2[]>[
                { key: "ncbi", name: "NCBI", align: "center" },
                { key: "transcripts", name: i18n.t("Transcript", 2), align: "center" },
                { key: "exon", name: i18n.t("Exon", 2), align: "center" },
                { key: "size", name: i18n.t("Layout.TypeLength", { type: "Gene" }, 2), align: "center" },
                { key: "molecular_weight", name: i18n.t("MolecularWeight"), align: "center" },
                { key: "related_models", name: i18n.t("RelatedModels"), align: "center" },
                { key: "references", name: i18n.t("Reference"), align: "center" },
            ],
        };
    }
};
